import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"
import LoaderCircle from "components/LoaderCircle"

interface Props {
  confirmType: "approve" | "disapprove" | undefined
  setConfirmType: (type: "approve" | "disapprove" | undefined) => void
  onConfirm: () => void
  loading: boolean
}

const ApproveModal = ({ confirmType, setConfirmType, onConfirm, loading}: Props) => {
  return (
    <Dialog
      open={confirmType !== undefined}
      onClose={() => setConfirmType(undefined)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box sx={{ p: 1, py: 1.5 }}>
        {loading ? (
          <DialogTitle id="alert-dialog-title">
            {confirmType === "disapprove"
              ? "The disapproval process is in progress."
              : "Offer report is being generated, please wait."}
          </DialogTitle>
        ) : (
          <DialogTitle id="alert-dialog-title">
            {confirmType === "disapprove" ? "Disapprove Report Upload Request" : "Approve Report Upload Request"}
          </DialogTitle>
        )}
        <DialogContent>
          {loading ? (
            <div className="flex justify-center w-full h-10">
              <LoaderCircle width="20px" />
            </div>
          ) : (
            <DialogContentText id="alert-dialog-description">
              Are you sure you want to {confirmType === "disapprove" ? "disapprove " : "approve"} report upload request?
            </DialogContentText>
          )}
        </DialogContent>
        {!loading && <DialogActions>
          <Button color="error" onClick={() => setConfirmType(undefined)}>
            Cancel
          </Button>
          <Button variant="contained" onClick={onConfirm} disabled={loading}>
            {confirmType === "disapprove" ? "Disapprove " : "Approve"}
          </Button>
        </DialogActions>}
      </Box>
    </Dialog>
  )
}

export default ApproveModal
